import { TeamRole } from "entities/team-members/types/TeamRole"

import { TeamInvitationFragment } from "../graphql/fragments.generated"
import type { TeamInvitationStatus } from "./TeamInvitationStatus"

export interface TeamInvitation extends TeamInvitationFragment {
  role: TeamRole
  status: TeamInvitationStatus
}

export const TeamInvitationsAPIType = "team_invitations" as const

export const TeamInvitationTypename = "TeamInvitation" as const
